import { BookingStatus } from '../objects/bookingStatus';

export const BOOKING_STATUS_RTADUCTION: Record<BookingStatus, string> = {
    [BookingStatus.CONFIRMED]: 'status-confirmed',
    [BookingStatus.ERROR]: 'status-error',
    [BookingStatus.UNAVAILABLE]: 'status-unavailable',
    [BookingStatus.CANCELLED]: 'status-cancelled',
    [BookingStatus.PENDING]: 'status-pending',
    [BookingStatus.WAITING]: 'status-waiting',
    [BookingStatus.CANCEL_WAITING]: 'status-cancel-waiting',
    [BookingStatus.REFUSED]: 'status-refused'
};
